










import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class OkPopup extends Vue {
    @Prop() private text: string;
    @Prop() private open: boolean;

    private close() {
        this.root.setOkPopupOpen(false);
    }
}

Vue.component("mt-ok-popup", OkPopup);
